import loadable from '@loadable/component';
import { WithLazyHydration } from '../../WithLazyHydration';

const BroadsheetLoadable = loadable(() => import('./Broadsheet'), {
  resolveComponent: components => components.Broadsheet
});

export const Broadsheet = WithLazyHydration(BroadsheetLoadable, {
  name: 'Broadsheet'
});
